import provideDataHook from '~/helpers/provideDataHook';
import { objectsFilterDataHook } from '../objectsFilterDataHook';
import { RedirectHandler } from '../RedirectHandler';

export default provideDataHook(
  'FilterPage-RecreationalVehicle',
  objectsFilterDataHook({ mainCategories: ['recreational_vehicle'] }),
  { skipSpinner: true }
)(RedirectHandler);
